import { EntryTypeEnum } from '@insurance/api/requests'
import { RadioCardGroup } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { Form } from 'antd'
import { useTranslation } from 'react-i18next'

import { useHealthInsuranceValues } from './HealthInsuranceContext'

export const TripType = () => {
  const { t } = useTranslation()
  const { required } = useValidationsField()
  const { isEditable } = useHealthInsuranceValues()

  return (
    <Form.Item name="entry_type" label={t('trip_type')} rules={[required]}>
      <RadioCardGroup
        options={Object.values(EntryTypeEnum).map((value) => ({
          label: t(`${value}_entry`),
          value
        }))}
        disabled={isEditable}
      />
    </Form.Item>
  )
}
